export default function CommonCardSkeleton() {
  return (
    <div className="tw-animate-pulse tw-w-full tw-h-full tw-flex tw-space-x-4">
      <div className="tw-flex-1 tw-h-full tw-w-full tw-space-y-6 tw-py-1">
        <div className="tw-h-full tw-bg-iron-800 tw-rounded-lg"></div>
      </div>
    </div>
  );
}
